import { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogHeader,
  FormControl,
  Inline,
  Input,
  Stack,
  Textarea,
  Typography,
} from '@airbus/components-react';
import { t } from '../../../i18next';
import { postRequest } from '../../../shared/utils';

export const BackToNPIBoard = ({
  rowSelected,
  open,
  setOpen,
  setAlertbar,
  updatereRender,
  tableDetails,
}) => {
  const timestamp = new Date().toISOString().substring(0, 10);
  const [reason, setReason] = useState('');
  const [showPlaceholder, setShowPlaceholder] = useState(false);

  const handleTextareaChange = (e) => {
    setReason(e.target.value);
    if (e.target.value.trim()) {
      setShowPlaceholder(true);
    } else {
      setShowPlaceholder(false);
    }
  };

  const handleCancelAndClose = () => {
    setOpen(false);
    setReason('');
    setShowPlaceholder(false);
  };

  const handleConfirm = async () => {
    if (!reason.trim()) {
      setShowPlaceholder(true);
      return;
    }

    const npiComment = `${timestamp} : MoB decision was automatically set from ${rowSelected?.mob} to Rejected in NPI Steering. Reason: ${reason.trim()}`;
    const npiSet = {
      npi_comment: npiComment,
      pag_agenda: 1,
      npi_mob: 19,
      npi_mob_lastmodified: timestamp,
      npi_expd: null,
    };
    const npiUpdateObjects = [
      {
        where: { npi_htz: { _eq: rowSelected.htz } },
        _set: npiSet,
      },
    ];
    const sheet1Set = {
      indus_id: 1,
      indus_id_lastmodified: timestamp,
      steering_state: 'NPIO',
    };
    const sheet1UpdateObjects = [
      {
        where: { id1: { _eq: rowSelected.id1 } },
        _set: sheet1Set,
      },
    ];
    const schemaName = tableDetails.mbdDataGrid.schemaName;
    const npiPayload = {
      pkey: 'npi_id',
      schema: schemaName,
      table: 'npi',
      updateObjects: npiUpdateObjects,
    };
    const sheet1Payload = {
      pkey: 'id1',
      schema: schemaName,
      table: 'sheet1',
      updateObjects: sheet1UpdateObjects,
    };
    const result = await postRequest('/api/tables', {
      screenGridId: tableDetails.id,
      tables: [npiPayload, sheet1Payload],
    });
    if (result.errors) {
      setAlertbar({
        children: t('error.error_database'),
        severity: 'error',
      });
    } else {
      setAlertbar({ children: t('successfully_updated'), severity: 'success' });
      updatereRender();
    }
    setReason('');
    setShowPlaceholder(false);
    setOpen(false);
  };

  return (
    <Dialog open={open} onClose={handleCancelAndClose}>
      <Inline align='center'>
        <DialogHeader>
          <Typography variant='h6'>{t('npiSteering.back_to_npi')}</Typography>
        </DialogHeader>
      </Inline>
      <DialogContent>
        <Stack padding='3-x' spacing='4-x'>
          <FormControl label='HTZ' required>
            <Input value={rowSelected?.htz} />
          </FormControl>
          <FormControl
            required
            label={t('npiSteering.give_reason')}
            placeholder={showPlaceholder ? t('npiSteering.enter_reason') : ''}
          >
            <Textarea value={reason} onChange={handleTextareaChange} />
          </FormControl>
        </Stack>
      </DialogContent>
      <Inline align='center'>
        <DialogActions className='pt-0'>
          <Button variant='secondary' onClick={handleCancelAndClose}>
            {t('cancel')}
          </Button>
          <Button variant='primary' onClick={handleConfirm}>
            {t('confirm')}
          </Button>
        </DialogActions>
      </Inline>
    </Dialog>
  );
};
